import React from 'react';
import HostMonthlyEarningsPage from './HostMonthlyEarningsPage';

const HostTutorStatisticsPage: React.FC = () => (
  <HostMonthlyEarningsPage reportType="tutors" />
);

export default HostTutorStatisticsPage;
